import { memo, useSyncExternalStore } from "react";

import { ModalProvider } from "@sections/ModalProvider";
import { TablescapeContext } from "@tablescape/context";
import { PageModal } from "@tablescape/state";
import { type TablescapeState } from "@tablescape/state";

import { VideoModalView } from "./VideoModal.view";

const VideoModalBase = () => {
  const { videoModal } = useSyncExternalStore<TablescapeState>(
    TablescapeContext.onAll,
    TablescapeContext.getSnapshot
  );

  return (
    <ModalProvider
      render={({ closeModal }) => (
        <VideoModalView
          autoPlay
          controls
          fluid
          onClose={closeModal}
          sources={videoModal?.sources}
          subtitles={videoModal?.subtitles}
        />
      )}
      targetModal={PageModal.VIDEO_MODAL}
    />
  );
};

export const VideoModal = memo(VideoModalBase);
